export const ADD_FAVORITE = 'ADD_FAVORITE';
export const ADD_NOW_PLAYING_MOVIES = 'ADD_NOW_PLAYING_MOVIES';
export const SEARCH_RESULTS_MOVIES = 'SEARCH_RESULTS_MOVIES';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const QUERY = 'QUERY';
export const CHANGE_QUERY = 'CHANGE_QUERY';